<template lang="pug">
v-menu(rounded="lg" offset-y :close-on-content-click="false" min-width=300 max-height=320)
  template(v-slot:activator="{ on: menu, attrs }")
    v-tooltip(v-if="showTooltip" top color="black")
      template(v-slot:activator="{ on: tooltip }")
        v-btn(v-bind="attrs" v-on="{ ...menu, ...tooltip }" icon color="neutral500" :disabled="disabled")
          v-icon(:size="iconSize") $yzi-settings-02
      .text-xs.white--text {{ $t('customize_column') }}
    v-btn(v-else icon v-on="{ ...menu }" color="neutral500" :disabled="disabled")
      v-icon(:size="iconSize") $yzi-settings-02
  
  v-list(flat)
    v-list-item.px-6
      .text-md.font-semibold {{ $t('customize_column') }}
    v-list-item.px-6
      v-list-item-action.mr-2
        y-checkbox(input-value="true" disabled)
      v-list-item-content
        .d-flex.align-center
          .text-sm.flex-grow-1 Name
          .text-xs.neutral500--text System
    
    v-list-item-group
      v-list-item.px-6(v-for="option in options" :key="options.name")
        v-list-item-action.mr-2
          y-checkbox(v-model="option.enable" @onChecked="onChecked")
        v-list-item-content(@click.prevent="toggle(option)")
          .d-flex.align-center
            .text-sm.capitalize.flex-grow-1 {{ option.field_name | fieldNameDisplay }}
            .text-xs.capitalize.neutral500--text {{ option.type ? option.type : 'custom' }}

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    type: {
      type: String,
      default: null
    },
    showTooltip: {
      type: Boolean,
      default: true
    },
    iconSize: {
      type: [Number, String],
      default: null
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters({ 
      fields: 'customers/getAllFields',
      donorFields: 'donation/getAllFields',
      clinicFields: 'clinic/getAllFields',
      appointmentFields: 'clinic/getAppointmentFields',
      reviewInvitationFields: 'review/getInvitationFields',
    }),
    options () {
      switch (this.type) {
        case 'donor':
          return this.donorFields
        case 'patient':
          return this.clinicFields
        case 'appointment':
          return this.appointmentFields
        case 'review_invitation':
          return this.reviewInvitationFields
        default:
          return this.fields    
      }
    }
  },
  methods: {
    toggle (option) {
      option.enable = !option.enable
      this.saveSelectedField()
    },
    onChecked () {
      this.saveSelectedField()
    },
    saveSelectedField () {
      const ids = this.options.filter(option => option.enable).map(item => item.id)
      if (ids) {
        const key = !this.type ? 'yz_customer_fields' : `yz_${this.type}_fields`
        localStorage.setItem(key, JSON.stringify(ids))
      }
    }
  }
}
</script>